<template>
  <div class="fund-size-details">
    <RkTabs v-model="activeTab" :options="options" slider />
    <div class="edge-padding">
      <RkTable :data="fundResultData">
        <RkTableColumn prop="" label="周期" align="left"></RkTableColumn>
        <RkTableColumn prop="" label="涨跌幅"></RkTableColumn>
        <RkTableColumn prop="" label="追踪指数"></RkTableColumn>
      </RkTable>
    </div>
  </div>
</template>

<script>
import RkTabs from '@/components/common/RkTabs.vue'
export default {
  components: { RkTabs },
  data() {
    return {
      fundResultData: [],
      activeTab: '阶段收益',
      options: Object.freeze([
        {
          label: '阶段收益',
          value: '阶段收益'
        },
        {
          label: '季度收益',
          value: '季度收益'
        },
        {
          label: '年度收益',
          value: '年度收益'
        }
      ])
    }
  }
}
</script>

<style lang="scss" scoped>
.fund-size-details {
  background: var(--bg-color-2);
}
</style>
